import axios from 'axios';
// import { DispatchProp } from 'react-redux';
import { Dispatch } from 'redux';
import { API } from '../api';
import { TagTypes } from '../api/apiBase.types';
import { setRToken } from '../localStorage';
import { login, logout } from '../redux/reducers/session';
import { loginAPI } from './routes';

const login_req = (dispatch: Dispatch, token: string) => {
  dispatch(login(token));
};

const logout_req = (dispatch: Dispatch) => {
  dispatch(logout());
  dispatch(API.util.invalidateTags([TagTypes.CurrentSession]));
  dispatch(API.util.invalidateTags([TagTypes.CurrentUser]));
};

export { login_req, logout_req };
